import { AuthenticationResult, EventMessage, EventType, InteractionType } from "@azure/msal-browser"
import { MsalAuthenticationTemplate } from "@azure/msal-react"
import { CookiesProvider } from "react-cookie"
import { Provider } from "react-redux"
import App from "./components/App"
import configureStore from "./store/configureStore"
import { authProvider } from "./AzureADConfig"
import { getSecondsFromDays } from "./shared/utility"

const AppWithAuthentication = (): JSX.Element => {
    const store = configureStore();

    function ErrorComponent(error: any) {
        return <p>An Error Occurred: {error}</p>;
    }

    function LoadingComponent() {
        return <p>Authentication in progress...</p>;
    }

    const authRequest = {
        scopes: ["openid", "User.Read"]
    };

    authProvider.addEventCallback((message: EventMessage) => {
        if (message.eventType === EventType.LOGIN_SUCCESS) {
            const payload = message.payload as AuthenticationResult;
            authProvider.setActiveAccount(payload.account);
            store.dispatch({ type: "AAD_LOGIN_SUCCESS", payload: payload.account });
        }
    });

    return (
        <>
            <MsalAuthenticationTemplate
                interactionType={InteractionType.Redirect}
                authenticationRequest={authRequest}
                errorComponent={ErrorComponent}
                loadingComponent={LoadingComponent}
            >
                <Provider store={store}>
                    <CookiesProvider defaultSetOptions={{ path: '/', maxAge: getSecondsFromDays(90) }}>
                        <App />
                    </CookiesProvider>
                </Provider>
            </MsalAuthenticationTemplate>
        </>
    );
}

export default AppWithAuthentication;